import { Box, Grid, IconButton, Stack } from '@mui/material';
import { useState } from 'react';
import Map from '../Components/Map';
import { useTranslation } from 'react-i18next';
import { CardWrapper } from 'layout/PublicLayout/Wrappers';
import { ArrowBack } from '@mui/icons-material';
import ClubsGrid from '../Components/ClubsGrid';

const View = () => {
    const [selectedRegion, setSelectedRegion] = useState(0);
    const { t } = useTranslation();

    if (!selectedRegion)
        return (
            <CardWrapper>
                <Grid container justifyContent="center" sx={{ height: '100%', alignItems: 'center' }}>
                    <Map setSelectedRegion={setSelectedRegion} />
                </Grid>
            </CardWrapper>
        );
    return (
        <Stack spacing={2} sx={{ width: '100%', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', width: '80%', borderRadius: 2, background: '#F8F8F8', boxShadow: 1, px: 5, py: 1 }}>
                <IconButton onClick={() => setSelectedRegion(null)}>
                    <ArrowBack sx={{ width: 18 }} />
                </IconButton>
            </Box>
            <CardWrapper>
                <ClubsGrid />
            </CardWrapper>
        </Stack>
    );
};

export default View;
